/**
 * Debug mode helper
 *
 * NOTE: This intentionally duplicates the existing logic from src/lib/analytics.ts
 * so we can import debug utilities from a dedicated module (e.g. in ScanForm).
 *
 * Debug mode is used to:
 * - exclude test scans from analytics
 * - prevent outbound notifications (e.g. Discord)
 * - enable mock-mode behavior in the UI (no paid API calls)
 */
export const isDebugMode = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const hostname = window.location.hostname;
    const isPreview = hostname.includes("preview");
    const urlParams = new URLSearchParams(window.location.search);
    const urlParam = urlParams.get("debug") === "true" || urlParams.get("test") === "true";
    const sessionFlag = sessionStorage.getItem("debug_mode_session") === "true";
    const localFlag = localStorage.getItem("debug_mode") === "true";

    const result = isPreview || urlParam || sessionFlag || localFlag;

    // Save to storage if URL param is present
    if (urlParam) {
      localStorage.setItem("debug_mode", "true");
      sessionStorage.setItem("debug_mode_session", "true");
    }

    // Handle explicit disable
    if (urlParams.get("debug") === "false") {
      localStorage.removeItem("debug_mode");
      sessionStorage.removeItem("debug_mode_session");
      return false;
    }

    return result;
  } catch {
    return false;
  }
};
